import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { Windmill } from "@windmill/react-ui";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ThemedSuspense from "./components/ThemedSuspense";
import { SidebarProvider } from "./context/SidebarContext";
import { AdminProvider } from "./context/AdminContext";
import { ThemeProvider } from "./context/ThemeContext";
import ToastProvider from "./context/ToastProvider";
import { GlobalStateProvider } from "./context/GlobalStateContext";
import Layout from "./containers/Layout";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import UsersRoute from "./helpers/UsersRoute";
import AdminRoute from "./helpers/AdminRoute";
import { useAdmin } from "./context/AdminContext";
import "./index.css";

const Login = lazy(() => import("./pages/Login"));
const EmployeeProfile = lazy(() => import("./pages/Profiles/EmployeeProfile"));
const UserProfile = lazy(() => import("./pages/Profiles/UserProfile"));
const FieldAgents = lazy(() => import("./pages/FieldAgents"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));

function App() {
  const { userProfile } = useAdmin();

  return (
    <Router>
      <ToastContainer position="top-right" autoClose={5000} />
      <AccessibleNavigationAnnouncer />
      <Switch>
        <Redirect exact from="/" to="/login" />
        <Route exact path="/login" component={Login} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/agent/collection" component={FieldAgents} />
        <UsersRoute
          path="/user/:id"
          component={UserProfile}
          user={userProfile}
        />
        <UsersRoute
          path="/employee/:id"
          component={EmployeeProfile}
          user={userProfile}
        />
        <AdminRoute path="/app" component={Layout} />  {/* Remove the /* */}
      </Switch>
    </Router>
  );
}



export default App;